.calendarContentsWrapper {
  display: inline-block;
  width: 100%;

  @media (min-width: 1320px) {
    margin: 0 auto;
  }
}
